export const colors = {
  brand: '#16a34a',
  brandLight: '#dcfce7',
  brandDark: '#15803d',
  brand50: '#f0fdf4',

  bg: '#fafafa',
  white: '#ffffff',

  ink: '#111827',
  inkSecondary: '#4b5563',
  inkMuted: '#9ca3af',

  line: '#e5e7eb',
  lineHover: '#d1d5db',

  danger: '#dc2626',
  dangerLight: '#fef2f2',

  amber: '#d97706',
  amber50: '#fffbeb',
  amber100: '#fef3c7',
  amber200: '#fde68a',

  blue50: '#eff6ff',
  blue200: '#bfdbfe',
  blue700: '#1d4ed8',
} as const;

export const radius = {
  sm: 8,
  md: 12,
  card: 14,
  lg: 18,
  xl: 24,
  full: 999,
} as const;

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  '2xl': 24,
  '3xl': 32,
} as const;

export const font = {
  regular: '400' as const,
  medium: '500' as const,
  semibold: '600' as const,
  bold: '700' as const,
  extrabold: '800' as const,
};
